import {NgIf} from "@angular/common";
import {Component, OnDestroy, OnInit} from '@angular/core';
import {FlexModule} from "@angular/flex-layout";
import {MatDivider} from "@angular/material/divider";
import {PrintListenerService} from "@shared-services/print/print-listener.service";
import {PageOffering} from "projects/soko-console-web-v2/src/app/core/model/side-nav.model";
import {
  FeatureLeadsModule
} from "projects/soko-console-web-v2/src/app/core/modules/landlord-portal/features/feature-leads.module";
import {
  ConsoleAuthenticationService
} from "projects/soko-console-web-v2/src/app/security/console-authentication.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-print-application',
  standalone: true,
  imports: [
    FeatureLeadsModule,
    FlexModule,
    MatDivider,
    NgIf
  ],
  templateUrl: './print-application.component.html'
})
export class PrintApplicationComponent implements OnInit, OnDestroy {
  retailerId!: string;
  offering!: PageOffering;

  showData = false;
  private headersSubscription?: Subscription;
  private timeoutId?: number;

  constructor(private printListenerService: PrintListenerService,
              private auth: ConsoleAuthenticationService) {
  }

  ngOnInit() {
    // Set the 10-second timeout
    this.timeoutId = window.setTimeout(() => {
      console.log('Timeout reached - headers not received within 10 seconds');
      this.auth.logout();
    }, 10000);


    this.headersSubscription = this.printListenerService.headers$.subscribe({
      next: (headers) => {
        if (headers) {
          // Headers received - clear the timeout
          if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
          }

          this.retailerId = headers['x-retailer-id'];
          this.showData = true;
        }
      }
    });
  }

  ngOnDestroy() {
    // Clean up subscription and timeout
    if (this.headersSubscription) {
      this.headersSubscription.unsubscribe();
    }
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }


}
